import type { RequestConfig } from '@customTypes/index';
import type { ClubPhotoTag, PhotoItemDto } from '@customTypes/types';
import qs from 'qs';

import { api } from '@/shared/api/instance';

export type GetClubProfilePhotoListRequest = {
  profileId: string;
  tags?: ClubPhotoTag[] | ClubPhotoTag;
};

export type GetClubProfilePhotoListParams =
  RequestConfig<GetClubProfilePhotoListRequest>;

export const getClubProfilePhotoList = async ({
  params,
  config
}: GetClubProfilePhotoListParams) =>
  api.get<PhotoItemDto[]>(`/api/photos/club/${params.profileId}`, {
    ...config,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
    params: { tags: params.tags }
  });
